import { Breadcrumb, Skeleton, Row, Col, Select } from 'antd';
import { ButtonAction, Card, Form, FormItem, GetValidateFields, Input, Confirm, Button, generateSlugify, Toggle } from 'asumsi-components';
import { LayoutCMS } from 'components';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import useAction from '@pages/videos/hooks/useAction';
import SunEditor from 'suneditor-react';
import useActionTopics from "@pages/topics/hooks/useAction";
import { ITopic } from '@interfaces/iresponse-news-crawler';

const { Option } = Select;
export const PageVideosFormComponent = (props: any) => {
    // set header page
    const title = 'Video Page'
    const layoutCMSProps = {
        breadcrumb: (
            <>
                <Breadcrumb.Item>
                    {title}
                </Breadcrumb.Item>
            </>
        ),
        documentTitle: title,
        history: props.history,
        pageTitle: title,
    };

    // declare action and attribute needed
    const { isLoader, getDetail, updateData, detail } = useAction();
    const { getData: getTopics, isLoader: isLoaderListTopic, data: dataListTopic } = useActionTopics();
    const { match } = props;
    const idData = match.params.id;

    // initiate form data
    const initialFieldsValues: any = {
        title: null,
        description: null,
        topicId: null
    };

    const [fieldsValues, setFieldsValues]: any = useState(initialFieldsValues);
    const [showConfirmation, setShowConfirm] = useState(false);
    const [paramSubmit, setParamSubmit] = useState({});
    const [content, setContent] = useState();

    // first load
    useEffect(() => {
        fetchTopic();
        if (idData && !detail) {
            getDetail(idData);
        }
        if (idData && detail) {
            setDefault();
        }
    }, [detail])

    const fetchTopic = (search?: string) => {
        getTopics({ page: 1, limit: 20, status: "active", search })
    }

    // fetch data
    const setDefault = async () => {
        if (detail) {
            setFieldsValues({
                title: detail.title,
                isActive: detail.isActive,
                description: detail.description,
                topicId: detail.topicId
            });
        }
    }

    // handle submit form
    const handleSubmit = (e: any) => {
        let fieldsVal: any = fieldsValues;
        fieldsVal = { ...fieldsVal, description: content };
        const validateFields = GetValidateFields(fieldsVal);
        const { err, values } = validateFields;
        e.preventDefault();
        if (!err) {
            setParamSubmit(values);
            setShowConfirm(true);
        }
    };

    const onChangeContent = (value: any) => {
        setContent(value)
    }

    const onChangeSlug = (e: any) => {
        const val: string = e.target.value;
        const slug = generateSlugify(val);
        const errors = fieldsValues.errors;
        if (errors) {
            const index = errors.findIndex((element: string) => element == 'slug');
            if (index >= 0) {
                errors.splice(index, 1);
            }
        }

        if (!slug) {
            errors.push('slug');
        }

        setFieldsValues({ ...fieldsValues, errors, slug });
    }

    const onChangeTopic = (value: string) => {
        if (!value) {
            fetchTopic();
        }
        setFieldsValues({ ...fieldsValues, topicId: value });
    }

    const topicsOptions = dataListTopic.map((topic: ITopic) => <Option key={topic.id} value={topic.id}>{topic.name}</Option>)

    // return JSX Element 
    return (
        <LayoutCMS {...layoutCMSProps}>
            <Card className="asumsi-card-form-shadow-rd-15">
                <Form>
                    <Skeleton loading={isLoader}>
                        <Row gutter={30}>
                            <Col lg={{ span: 24 }} md={{ span: 24 }} xs={{ span: 32 }}>
                                <Row>
                                    <Col span={24}>
                                        <FormItem setFieldsValues={setFieldsValues} fieldsValues={fieldsValues} label="Title" labelAlign="left"
                                            fieldDecorator={{
                                                label: "title",
                                                rules: [{
                                                    message: 'Please input title',
                                                    required: true,
                                                }
                                                ]
                                            }}
                                        >
                                            <Input id="title" defaultValue={fieldsValues.title} onChange={onChangeSlug} />
                                        </FormItem>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={12}>
                                        <FormItem
                                            fieldsValues={fieldsValues}
                                            fieldDecorator={{
                                                label: 'topicId'
                                            }}
                                            label="Topic"
                                            setFieldsValues={setFieldsValues}
                                        >
                                            <Select
                                                loading={isLoaderListTopic}
                                                id="topicId"
                                                style={{ width: "90%" }}
                                                allowClear
                                                onSearch={fetchTopic}
                                                showSearch
                                                optionFilterProp="children"
                                                defaultValue={fieldsValues.topicId}
                                                value={fieldsValues.topicId}
                                                onChange={onChangeTopic}
                                                placeholder="Please select topic"
                                            >
                                                {topicsOptions}
                                            </Select>
                                        </FormItem>
                                    </Col>
                                    <Col span={12}>
                                        <FormItem width="50%" setFieldsValues={setFieldsValues} fieldsValues={fieldsValues} label="Active" labelAlign="left"
                                            fieldDecorator={{
                                                label: "isActive"
                                            }}
                                        >
                                            <Toggle id="isActive" defaultChecked={fieldsValues.isActive} />
                                        </FormItem>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={24}>
                                        <FormItem setFieldsValues={setFieldsValues} fieldsValues={fieldsValues} label="Description" labelAlign="left"
                                            fieldDecorator={{
                                                label: "description"
                                            }}
                                        >
                                            <SunEditor setContents={fieldsValues.description} onChange={onChangeContent} height="280px" enableToolbar={true} setOptions={{
                                                resizingBar: false,
                                                mode: "classic",
                                                font: ['Arial', 'Comic Sans MS', 'Courier New', 'Georgia', 'IBM Plex Serif', 'Impact', 'Inter', 'tahoma', 'Trebuchet MS', 'Verdana'],
                                                katex: "window.katex",
                                                imageGalleryUrl: "https://etyswjpn79.execute-api.ap-northeast-1.amazonaws.com/suneditor-demo",
                                                buttonList: [
                                                    [
                                                        "undo",
                                                        "redo",
                                                        "font",
                                                        "fontSize",
                                                        "formatBlock",
                                                        "paragraphStyle",
                                                        "blockquote",
                                                        "bold",
                                                        "underline",
                                                        "italic",
                                                        "strike",
                                                        "subscript",
                                                        "superscript",
                                                        "fontColor",
                                                        "hiliteColor",
                                                        "textStyle",
                                                        "removeFormat",
                                                        "outdent",
                                                        "indent",
                                                        "align",
                                                        "horizontalRule",
                                                        "list",
                                                        "lineHeight",
                                                        "table",
                                                        "link",
                                                        "image",
                                                        "video",
                                                        "audio",
                                                        "math",
                                                        "imageGallery",
                                                        "fullScreen",
                                                        "showBlocks",
                                                        "codeView",
                                                        "preview",
                                                        "print",
                                                        "save"
                                                    ]
                                                ],
                                            }} />
                                        </FormItem>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Skeleton>
                    <ButtonAction
                        left={
                            <Link to="/article/videos">
                                <Button type="outline-red" size="medium" disabled={isLoader} text="Cancel"></Button>
                            </Link>
                        }
                        right={
                            <Button type="green" size="medium" disabled={fieldsValues.errors && fieldsValues.errors.length > 0} loading={isLoader} onClick={handleSubmit}>
                                Save
                            </Button>
                        }
                    />
                </Form>
            </Card>
            <Confirm
                key="confirm-save"
                show={showConfirmation}
                setShow={setShowConfirm}
                onOk={async () => {
                    // do update data
                    updateData(paramSubmit, idData);
                }}
                content='Apakah Anda yakin untuk menyimpan data ini?'
                title='Konfirmasi'
                okText='Ya'
                cancelText='Tidak'
            />
        </LayoutCMS>
    );
};
export default PageVideosFormComponent;



// WEBPACK FOOTER //
// ./src/pages/videos-form/component.tsx